import React from 'react';
import { Link } from 'react-router-dom';
import SocialShare from './SocialShare';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 dark:bg-gray-950 text-white transition-colors duration-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Informations de l'institut */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-blue-600 dark:bg-blue-500 rounded-full flex items-center justify-center">
                <span className="text-white font-bold"><img src="logo-principal.png" alt="logo" /></span>
              </div>
              <div>
                <h3 className="text-xl font-bold text-white">ISTMECH</h3>
                <p className="text-sm text-gray-400 dark:text-gray-300">Institut Supérieur de Technologie Médicale</p>
              </div>
            </div>
            <p className="text-gray-300 dark:text-gray-200 leading-relaxed mb-6">
              Former des technologistes médicaux compétents pour contribuer au développement
              du système de santé haïtien avec excellence et éthique professionnelle.
            </p>
            <SocialShare />
          </div>

          {/* Liens rapides */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">Liens Rapides</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/a-propos#mot-directeur"
                  className="text-gray-400 dark:text-gray-300 hover:text-white transition-colors duration-200"
                >
                  Mot du Directeur
                </Link>
              </li>
              <li>
                <Link
                  to="/a-propos#historique"
                  className="text-gray-400 dark:text-gray-300 hover:text-white transition-colors duration-200"
                >
                  Historique
                </Link>
              </li>
              <li>
                <Link
                  to="/formations#informations-generales"
                  className="text-gray-400 dark:text-gray-300 hover:text-white transition-colors duration-200"
                >
                  Informations Générales
                </Link>
              </li>
              <li>
                <Link
                  to="/vie-etudiante#reglements"
                  className="text-gray-400 dark:text-gray-300 hover:text-white transition-colors duration-200"
                >
                  Règlements
                </Link>
              </li>
              <li>
                <Link
                  to="/formations#criteres-reussite"
                  className="text-gray-400 dark:text-gray-300 hover:text-white transition-colors duration-200"
                >
                  Critères de Réussite
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <svg className="w-5 h-5 text-blue-400 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <div>
                  <p className="text-gray-300 dark:text-gray-200">Hôpital Universitaire Justinien</p>
                  <p className="text-gray-400">Rue 17 Q, Cap-Haïtien</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <svg className="w-5 h-5 text-blue-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <p className="text-gray-300 dark:text-gray-200">+509 22 60 12 92</p>
              </div>
              <div className="flex items-center space-x-3">
                <svg className="w-5 h-5 text-blue-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                {/* <p className="text-gray-300 dark:text-gray-200">istmech@yahoo.fr</p><br /> */}
                <p className="text-gray-300 dark:text-gray-200">
                  contact@istmech.edu.ht</p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 dark:border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 dark:text-gray-300 text-sm">
            © {currentYear} ISTMECH - Institut Supérieur de Technologie Médicale du Cap-Haïtien. Tous droits réservés.
          </p>
          <p className="text-gray-500 dark:text-gray-400 text-xs mt-2 md:mt-0">
            Conçu par <strong className="text-green-600 dark:text-green-400"><a href="https://kolabotech.com" target="_blank" rel="noopener noreferrer">Kolabo Tech</a></strong> pour l'excellence en technologie médicale
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
